<template>
    <div class="col-12" style="margin-top: 2.5em">
        <div class="col-12 main-container">
            <div class="content-container col-lg-6 mx-auto">
                <div class="text-center mx-auto p-2 pt-4">
                    <span class="no-results">{{ $t("payment.payment_success")}}</span>
                    <div class="col-12 mx-auto pt-3">
                        <b-button
                                class="fair-button"
                                variant="success"
                                @click.stop="goToCampaignView"
                        >
                            {{ $t("payment.redirect")}}
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: "payment-success-view",
        data() {
            return {
                timeout: null
            }
        },
        mounted() {
            if (this.$route.query.session_id) {
                this.transactionCompleted()
            } else {
                this.goToCampaignView()
            }
        },
        methods: {
            transactionCompleted: function () {
                this.timeout = setTimeout(this.goToCampaignView, 10000)
            },

            goToCampaignView: function () {
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }
                this.$router.push({name: 'main-view'})
            }
        }
    }
</script>

